import React from 'react';
import {Route, Routes} from "react-router-dom";

import LoginForm from "../components/Auth/LoginForm";
import RegisterForm from '../components/Auth/RegisterForm';
import Complain from '../components/complain/complain';
import RegistrationTrader from '../components/TraderRegistration/RegistrationTrader';
import RegistrationTraderSwahili from '../components/TraderRegistration/RegistrationTraderSwahili';

function AuthRoute(props) {
    return (
       <Routes>
         <Route path="/" element={<LoginForm />} />
                <Route path="/login" element={<LoginForm />} />
                <Route path="/register" element={<RegisterForm />} />
                <Route path="/complain" element={<Complain />} />
                <Route path="/cross-border-registration" element={<RegistrationTrader />} />
                <Route path="/cross-border-registration-sw" element={<RegistrationTraderSwahili />} />
                 
                <Route path="*" element={<LoginForm />} />
       </Routes>
    );
}

export default AuthRoute;